import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { UploadFileDialog } from 'shell/components';

const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
];

const StudentUploadSubmissionsDialog = ({ open, assignment, onClose, onClick }) => {
    const { course } = useApp();
    const { auth } = useAuth();

    const handleClickUpload = (files) => {
        onClick(
            files.map((file) => ({
                ...file,
                owner_account_id: auth.id,
                course_id: course.id,
                assignment_id: assignment.id,
            }))
        );
        onClose();
    };

    return (
        <UploadFileDialog
            allowedFileTypes={ALLOWED_FILE_TYPES}
            description={''}
            max={1}
            open={open}
            title={'Upload Submission'}
            onClickUpload={handleClickUpload}
            onClose={onClose}
        />
    );
};

export default StudentUploadSubmissionsDialog;
